import { Link } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { TextField, useFormField } from '@frontend/design-system';
import { FloatingButton } from './floating-button';
import { iconStyling, toolbarStyling } from './styles';

type Props = {
  handleSubmit: (link: Link) => void;
  link?: Link;
  setShow: (show: boolean) => void;
  showLinkText?: boolean;
};

export const CustomLinkToolbar = ({ handleSubmit, link, setShow, showLinkText, ...rest }: Props) => {
  const { t } = useTranslation('content-composer');
  const linkFieldProps = useFormField({ type: 'text', value: link?.url }, [link?.url]);
  const linkTextFieldProps = useFormField({ type: 'text', value: '' });

  const hasCompleteLink =
    (showLinkText && linkFieldProps.value && linkTextFieldProps.value) || (!showLinkText && linkFieldProps.value);

  const onSubmit = () => {
    if (hasCompleteLink) {
      handleSubmit({
        ...link,
        linkType: 'custom',
        url: linkFieldProps.value,
        ...(showLinkText ? { text: linkTextFieldProps.value } : {}),
      });
    }
  };

  return (
    <FloatingButton css={toolbarStyling} {...rest}>
      <Icon name='back' css={iconStyling} onClick={() => setShow(false)} />
      {showLinkText && (
        <TextField
          {...linkTextFieldProps}
          name=''
          label=''
          autoFocus
          placeholder={t('Link Text')}
          css={{ width: showLinkText ? 200 : 450 }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSubmit();
          }}
        />
      )}
      <TextField
        {...linkFieldProps}
        name=''
        label=''
        autoFocus
        placeholder={t('Link URL')}
        css={{ width: showLinkText ? 200 : 450 }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSubmit();
        }}
      />
      <Icon name='check' color={hasCompleteLink ? 'primary' : 'disabled'} onClick={onSubmit} />
    </FloatingButton>
  );
};
